__webpack_require__.p = "/eval-notification-and-activity-/onboarding/";